import {Injectable} from '@angular/core';
// import {Http, Headers, RequestOptions, Response, URLSearchParams} from '@angular/http';
import {HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpRequest} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {tap, map, switchMap, exhaustMap, catchError, take, delay, first, mergeMap, takeUntil} from 'rxjs/operators';
// import { tokenNotExpired, JwtHelper} from 'angular2-jwt';
import {Credentials, CrmUser} from '@app-models/index';
import {APIs} from '@app-settings/index';
import {HttpHeaderService} from '@app-services/http-header.service';
import {AppService} from '@app-services/app.service';
import {Subject} from "rxjs";

@Injectable()
export class AuthService {
	user: any;

	constructor(
		private _httpClient: HttpClient,
		private _httpHeaderService: HttpHeaderService,
		private _appService: AppService
	) {
		this.getStoredUser();
	}

	getHttpHeader() {
		const token = this._appService.accessToken;
		if (!token)
			return null;

		let option = {
			'Content-Type': 'application/json; charset=utf-8',
			'Access-control-Allow-Origin': '*',
			'Access-Control-Allow-Methods': 'POST,OPTIONS,GET',
			'Access-Control-Allow-Headers': 'Access-Control-Allow-Origin',
			'Authorization': `Bearer ${token}`,
		};
		return new HttpHeaders(option);
	}

	loginWithToken() {
		const headers = this.getHttpHeader();
		return this._httpClient.post(APIs.login_with_token, {}, {headers: headers});
	}

	login(credentials: Credentials) {
		const header = {headers: new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8')};
		const body = {
			'grant_type': 'password',
			'emailOrUsername': credentials.emailOrUsername,
			'password': credentials.password
		}
		return this._httpClient.post(APIs.login, body, header);
	}

	refreshToken(token: string) {
		if (!token)
			return of(null);

		const header = {headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded;charset=utf-8')};
		const body = new URLSearchParams();
		body.set('grant_type', 'refresh_token');
		body.set('refresh_token', token);
		body.set('scope', 'offline_access');
		return this._httpClient.post(APIs.login, body.toString(), header);
	}

	getUserLanguagesByEmail(email) {
		const headers = this._httpHeaderService.getNormalHttpHeader();
		let params: HttpParams = new HttpParams();
		params = params.set('email', email);

		return this._httpClient.get(`${APIs.crm_users}/languages`, {headers: headers, params: params});
	}

	switchUser(uuid) {
		const headers = this._httpHeaderService.getNormalHttpHeader();
		if (!headers) return of(null);
		return this._httpClient.post(APIs.switchUser, { omUuid: uuid }, {headers: headers});
	}

	getUserInfo() {
		const headers = this.getHttpHeader();
		if (!headers) return of(null);
		return this._httpClient.get(APIs.user_info, {headers: headers});
	}

	getCountryTranslations(userUuid) {
		const headers = this.getHttpHeader();
		if (!headers) return of(null);
		return this._httpClient.get(APIs.crm_settings + `/get-country-translation?uuid=${userUuid}`, {headers: headers});
	}

	updateUser(body: CrmUser) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.post(APIs.auth_update, body, {headers: headers});
	}
	requestpassword(email) {
		const header = {headers: new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8')};
		return this._httpClient.post(`${APIs.auth_request_password}?email=${email}`, header);

	}
	verifycode(email,token) {
		const header = {headers: new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8')};
		return this._httpClient.post(`${APIs.auth_verify_code}?email=${email}&token=${token}`, header);

	}
	resetpassword(email,token,password) {
		const header = {headers: new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8')};
		return this._httpClient.post(`${APIs.auth_restore_password}?email=${email}&token=${token}&password=${password}`, header);

	}

	register(body: CrmUser) {
		const headers = new HttpHeaders();
		headers.append('Content-Type', 'application/json; charset=utf-8');
		return this._httpClient.post(APIs.auth_register, body, {headers: headers});
	}

	resendEmail(email) {
		const headers = new HttpHeaders();
		headers.append('Content-Type', 'application/json; charset=utf-8');
		return this._httpClient.post(APIs.auth_email_resend, {email: email}, {headers: headers});
	}

	changePassword(body: { uuid:any, oldPassword: string, newPassword: string }) {
		if (!this.getHttpHeader()) return of(null);
		return this._httpClient.post(APIs.auth_password_change, body, {headers: this.getHttpHeader()});
	}

	getStoredUser() {
		this.user = localStorage.getItem('user');
	}

	canAccess(val: any[]): any {
		// Getting the profile
		let profile;

		if (this.user) {
			profile = JSON.parse(this.user);
		} else if (this._appService.user) {
			profile = this._appService.user;
		}

		// Role verification
		if (val.indexOf(profile.user_role) > -1) {
			return true;
		} else {
			return false;
		}
	}
}
